import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Toggle } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  card: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.std,
    flex: 1,
    minWidth: theme.maxContentWidth.regular,
  },
  title: {
    ...theme.fonts.h4,
    padding: theme.marginBase * 3,
    flex: 1,
  },
  topLine: {
    position: 'relative',
    width: '100%',
  },
  toggle: {
    position: 'absolute',
    top: theme.marginBase * 3,
    right: theme.marginBase * 3,
    width: 'auto',
    margin: 0,
  },
}));

interface Props {
  children: React.ReactNode;
  title: string;
  toggleLabel?: string;
  toggleChecked?: boolean;
  toggleOnChange?: () => void;
}

export const StatsCard = ({
  children,
  title,
  toggleLabel,
  toggleChecked,
  toggleOnChange,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <div className={classes.topLine}>
        <h4 className={classes.title}>{title}</h4>
        {toggleLabel && toggleOnChange && (
          <Toggle
            onChange={toggleOnChange}
            checked={toggleChecked}
            label={toggleLabel}
            containerClass={classes.toggle}
          />
        )}
      </div>
      {children}
    </div>
  );
};
